<template>
  <b-card class="view-certificado">
    <certificados-list
      ref="certificadosList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros-rapidos="filtrosRapidos"
      :filtros="filtros"
      :ajuda="true"
    >
      <template slot="botoes-adicionais">
        <b-btn
          v-b-tooltip.hover
          title="Atualizar procuração"
          variant="none"
          class="btn btn-outline-primary mr-1"
          size="sm"
          @click="atualizarProcuracaoLote"
        >
          <font-awesome-icon icon="fa-solid fa-rotate" />
          Atualizar Procuração
        </b-btn>
      </template>
      <template
        slot="custom"
        slot-scope="{ props }"
      >
        <span
          v-if="props.column.field === 'vencimento'"
        >
          <b-badge
            v-if="props.row.situacao === 'CertificadoRevogado'"
            v-b-tooltip.hover
            title="O certificado encontra-se revogado. Faça a troca para continuar tendo acesso as funcionalidades do sistema"
            style="background-color: #c8a8e3; color: #64249c;"
          >
            Certificado Revogado
          </b-badge>
          <b-badge
            v-else-if=" props.row.situacao === 'CpfDiferente'"
            v-b-tooltip.hover
            title="O CPF do responsável contido no certificado digital é diferente do CPF do responsável pela empresa nas bases de dados da Receita Federal do Brasil"
            variant="light-warning"
          >
            Cadastro CPF sócio
          </b-badge>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>

        <!-- Lógica para coluna status -->
        <span
          v-else-if="props.column.field === 'status'"
        >
          {{ (() => {
            return props.row.situacao === 'CertificadoVencido' ? 'Certificado Vencido' : props.formattedRow[props.column.field]
          })() }}
        </span>

        <!-- Lógica para coluna criadoEm -->
        <span
          v-else-if="props.column.field === 'criadoEm'"
        >
          {{ formatarDataInclusao(props.row.criadoEm) }}
        </span>
      </template>

      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <span class="acoes-grid">

          <b-btn
            v-if="isAdmin"
            :id="`botao-cadastro${props.row.id}`"
            v-b-tooltip.hover="{ boundary: 'window' }"
            variant="none"
            class="btn rounded-pill building-circle-exclamation p-0"
            style="margin-right:0.6rem; margin-left:0.6rem;"
            :disabled="props.row.situacao == 'CertificadoVencido' || props.row.situacao == 'CertificadoRevogado' ? true : false"
            :title="props.row.situacao == 'CertificadoVencido' || props.row.situacao == 'CertificadoRevogado' ? '' : 'Importar empresas vinculadas ao certificado'"
            @click="openModalVincularEmpresasCertificado(props.row)"
          >
            <font-awesome-icon
              icon="fa-building-circle-exclamation"
              class="fa-light building-circle-exclamation text-primary"
            />
          </b-btn>
        </span>
        <atualizacao-procuracao
          :row="props.row"
          @atualizado="atualizarGrid"
        />
        <cadeado
          :row="props.row"
          @open-vinculo="openModalEmpresasVinculadas"
        />
      </template>

    </certificados-list>

    <template slot="conteudo">
      <b-row>
        <b-col>
          <fieldset class="font-weight-bold text-muted small">
            Selecione as Permissões que deseja para este usuário
          </fieldset>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 1px solid #a3a4a66b !important;"
          >
        </b-col>
      </b-row>
    </template>
    <empresas-vinculadas ref="empresas-vinculadas" />
    <certificado-ajuda ref="certificadoAjuda" />
    <modal-historico-certificado ref="modalHistoricoCertificado" />
  </b-card>

</template>

<style lang="scss" scoped>
  .text-purple {
    color: #64249c;
  }
  .text-purple:hover {
    color: #64249c;
  }
  .view-certificado ::v-deep {
    .col-razao-social-certificado {
      max-width: 320px;
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          max-width: 100%;
        }
      }
    }

    .col-td-acao-4 .acoes-grid {
      display: flex !important;
      align-items: center;
    }

    .col-td-acao-4 button,
    .col-td-acao-4 .btn {
      padding: 0 !important;
      margin: 0 0.5rem 0 0 !important;
    }

    .col-td-acao-4 svg {
      width: 1.15rem !important;
      height: 1.15rem !important;
      padding: 0 !important;
    }
  }
</style>

<script>

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import api from '@/app/certificado-digital/shared/services/api'
import { isAdmin } from '@/auth/utils'
import moment from 'moment'
import colunas from './shared/components/colunas'
import CertificadoAjuda from './CertificadoAjuda.vue'

export default {
  name: 'CertificadosVisualizacao',
  components: {
    CertificadosList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    EmpresasVinculadas: () => import('./shared/components/vinculo-empresas/components/empresas-vinculadas/ModalEmpresasVinculadas.vue'),
    Cadeado: () => import('./shared/components/cadeado/Cadeado.vue'),
    AtualizacaoProcuracao: () => import('./shared/components/atualizacao-procuracao/AtualizacaoProcuracao.vue'),
    CertificadoAjuda,
    ModalHistoricoCertificado: () => import('./shared/components/historico/ModalHistoricoCertificado.vue'),
  },
  data() {
    return {
      isAdmin: isAdmin(),
      botoesOption: {
        novo: {
          evento: this.novo,
        },
        baixar: {
          evento: this.baixarEmExcel,
        },
        editar: {
          evento: this.editar,
        },
        remover: {
          evento: this.remover,
        },
        historico: {
          evento: this.abrirHistorico,
        },
        ajuda: {
          evento: this.abrirAjuda,
        },
      },
      filtroAtual: {},
      visualizacao: {
        acaoClass: 'col-td-acao-4',
        placeholderBusca: 'Buscar por Nome ou Vencimento',
      },
      filtros: [{ colunas: ['Nome', 'Vencimento'], valor: null }],
      filtrosRapidos: [
        {
          id: 'ComProcuracao',
          colunas: ['Procuracao'],
          label: 'Com procuração',
          valor: true,
        },
        {
          id: 'SemProcuracao',
          colunas: ['Procuracao'],
          label: 'Sem procuração',
          valor: false,
        },
        {
          id: 'ComEmpresas',
          colunas: ['TemEmpresas'],
          label: 'Com empresa(s) vinculada(s)',
          valor: true,
        },
        {
          id: 'SemEmpresas',
          colunas: ['SemEmpresas'],
          label: 'Sem empresa(s) vinculada(s)',
          valor: false,
        },
        {
          id: 'Vencidos',
          colunas: ['Vencidos'],
          label: 'Vencidos / revogados / outros',
          valor: false,
        },
        {
          id: 'Vencidos30Dias',
          colunas: ['Vencidos30Dias'],
          label: 'Vencimento nos próximos 30 dias',
          valor: false,
        },
        {
          id: 'NenhumaAcaoRealizada',
          colunas: ['Status'],
          label: 'Nenhuma ação realizada',
          valor: '0',
        },
        {
          id: 'EnviadoSolicitacaoCadastro',
          colunas: ['Status'],
          label: 'Enviado solicitação de cadastro',
          valor: '1',
        },
        {
          id: 'CadastroEmpresasRealizada',
          colunas: ['Status'],
          label: 'Cadastro da empresas realizada',
          valor: '2',
        },
        {
          id: 'ErroCadastroEmpresas',
          colunas: ['Status'],
          label: 'Erro no cadastro das empresas, aguarde',
          valor: '3',
        }],
    }
  },

  mounted() {
    this.aplicarFiltroQuery()
    EventBus.$on('atualizaCertificadosVencidos', this.atualizarGrid)
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  beforeDestroy() {
    EventBus.$off('atualizaCertificadosVencidos', this.atualizarGrid)
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.colunas[0].evento = this.editar
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
  },
  methods: {
    formatarDataInclusao(data) {
      if (!data) return '-'
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    },
    baixarEmExcel(linhas) {
      this.filtroAtual.empresasSelecionadas = linhas
      api.baixarEmExcel(this.filtroAtual, linhas)
        .then(payload => {
          const arquivo = payload.data
          window.open(arquivo.url)
          api.deletarExcel(arquivo.url, arquivo.nomeArquivo)
          this.$sucesso('Exportação feita com sucesso')
        })
        .catch(err => {
          this.$erro(`Não foi possível fazer o download do arquivo. ${err.response.data.message}`)
          throw err
        })
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.certificadosList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.certificadosList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    atualizarGrid() {
      this.$refs.certificadosList.buscar()
    },
    // eslint-disable-next-line no-unused-vars
    carregar(pagina, tamanhoPagina, filtros) {
      this.filtroAtual = filtros
      return api.getPaginado(pagina, tamanhoPagina, filtros)
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro)
    },
    novo() {
      this.$router.push({ name: 'certificado-novo' })
    },
    editar(value) {
      this.$router.push({ name: 'certificado-editar', params: { id: value.id } })
    },
    remover(linhas) {
      const msgErro = linhas && linhas.length > 0 ? 'Não foi possível excluir um ou mais certificados' : 'Não foi possível o certificado'
      const ids = linhas && linhas.length > 0 ? linhas : linhas[0]
      return new Promise((resolve, reject) => {
        api.removerCertificado(ids)
          .then(payload => {
            if (payload.data === false) {
              reject(new Error(msgErro))
            }
            resolve(payload.data)
          })
          .catch(err => {
            reject(new Error(msgErro, err))
          })
      })
    },
    openModalVincularEmpresasCertificado(row) {
      Vue.swal({
        title: 'Importar empresas vinculadas a procuração no e-CAC?',
        html: '<br>O sistema executa uma rotina automática que acessa o e-CAC e verifica todas as empresas vinculadas por procuração ao certificado digital selecionado.<br>Esse processo pode levar até 72 horas para ser concluído, mas você pode continuar utilizando o sistema normalmente enquanto isso acontece.<br>Ao final da rotina, todas as empresas com procuração ativa serão cadastradas automaticamente na sua base de dados.<br><strong>Atenção:</strong> Caso a quantidade de CNPJs cadastrados ultrapasse o limite contratado, o valor da mensalidade poderá ser ajustado conforme o novo volume de empresas.<br><br><strong>Deseja realmente importar essas empresas?</strong>',
        icon: 'warning',
        width: '40%',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: {
          popup: 'swal-m',
          confirmButton: 'btn btn-outline-primary mr-50',
          cancelButton: 'btn btn-outline-warning ',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.isConfirmed) {
            Vue.swal({
              title: 'Atualizar vencimento de procuração',
              html: 'Para iniciar o processo de atualização, informe sua senha de rede.</br></br>',
              input: 'password',
              inputPlaceholder: 'Digite sua senha',
              inputAttributes: {
                autocapitalize: 'off',
                autocorrect: 'off',
                autocomplete: 'new-password',
              },
              icon: 'warning',
              width: '30%',
              showCancelButton: true,
              confirmButtonText: 'Confirmar',
              cancelButtonText: 'Cancelar',
              customClass: {
                popup: 'swal-m',
                confirmButton: 'btn btn-outline-primary mr-50',
                cancelButton: 'btn btn-outline-warning ',
              },
              buttonsStyling: false,
              preConfirm: senha => {
                if (!senha) {
                  Vue.swal.showValidationMessage('A senha é obrigatória')
                  return false
                }
                return senha
              },
            }).then(resultSenha => {
              if (resultSenha.isConfirmed) {
                api.cadastrarEmpresaPorCertificado(row.id, resultSenha.value)
                  .then(() => {
                    this.$sucesso('Cadastro iniciado com sucesso.', 'success')
                  })
                  .catch(err => {
                    Vue.prototype.$toast({
                      component: ToastificationContent,
                      props: {
                        title: err.response.data.message === 'A senha de rede especificada não está correta.' ? 'Senha Inválida!' : 'Problema ao cadastrar empresas. Tente novamente mais tarde.',
                        icon: 'fa-solid fa-circle-exclamation',
                        variant: 'danger',
                      },
                    })
                  })
              }
            })
          }
          return null
        })
    },
    openModalEmpresasVinculadas(row) {
      if (row.situacao !== 'SemEmpresaVinculada') {
        this.$refs['empresas-vinculadas'].showModal(row.id, row.nome)
      }
    },
    abrirAjuda() {
      if (this.$refs.certificadoAjuda) {
        this.$refs.certificadoAjuda.show()
      }
    },
    atualizarProcuracaoLote() {
      const linhasSelecionadas = this.$refs.certificadosList
        ? this.$refs.certificadosList.linhaSelecionada
        : []

      const dados = this.$refs.certificadosList?.gridInfo?.dados || []
      const idsComProcuracao = linhasSelecionadas.length > 0
        ? linhasSelecionadas.filter(id => {
          const row = dados.find(d => d.id === id)
          return row && row.porProcuracao === 'Sim'
        })
        : []

      if (linhasSelecionadas.length > 0 && idsComProcuracao.length === 0) {
        this.$aviso('Nenhum dos certificados selecionados possui procuração vinculada.')
        return
      }

      const body = idsComProcuracao.length > 0 ? { certificadoIds: idsComProcuracao } : {}
      api.atualizarVencimentoProcuracao(body)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Atualização da procuração concluída com sucesso. Acesse o dashboard para conferir.',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          this.atualizarGrid()
        })
        .catch(() => {
          this.$erro('Não foi possível atualizar as procurações. Tente novamente mais tarde.')
        })
    },
    abrirHistorico(linhas) {
      let ids = Array.isArray(linhas) && linhas.length > 0 ? linhas : null

      if (!ids && this.$refs.certificadosList && this.$refs.certificadosList.gridInfo) {
        const { dados } = this.$refs.certificadosList.gridInfo
        if (dados && dados.length > 0) {
          ids = dados.map(item => item.id)
        }
      }

      if (ids && this.$refs.modalHistoricoCertificado) {
        this.$refs.modalHistoricoCertificado.show(ids)
      }
    },
  },
}
</script>
